export const formatCurrency = (price: number, toFixed?: number): string =>
  `$${price.toFixed(toFixed ?? 2)}`;
